import { Link } from "react-router-dom";
import DocNavigation from "../../components/DocNavigation";

export default function FAQs() {
    return (
        <section className="space-y-10">

            {/* HEADER */}
            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-2">
                    Frequently Asked Questions
                </h1>

                <p className="text-md text-slate-600 max-w-3xl">
                    This section answers common questions about EventFlow’s features,
                    usage, and operational workflows.
                </p>

                <section className="bg-white border-l border-[#C9A24E] p-4 mt-4">
                    <h2 className="text-lg font-semibold mb-2">Overview</h2>
                    <p className="text-sm text-slate-600">
                        These FAQs help users quickly understand the system without needing
                        direct support.
                    </p>
                </section>
            </section>

            {/* GENERAL */}
            <section className="bg-slate-100 rounded-xl p-10">
                <h2 className="text-xl font-semibold mb-3">
                    General Questions
                </h2>

                <ul className="list-disc pl-5 text-slate-600 space-y-3">
                    <li>
                        <strong>Is EventFlow suitable for multiple venues?</strong><br />
                        Yes, EventFlow supports multi-venue management from a single dashboard.
                    </li>
                    <li>
                        <strong>Can I control user permissions?</strong><br />
                        Absolutely. You can assign roles like Admin, Manager, and Staff with specific access levels.
                    </li>
                    <li>
                        <strong>Does EventFlow support financial reporting?</strong><br />
                        Yes, we provide detailed financial reports including revenue, outstanding payments, and expense tracking.
                    </li>
                    <li>
                        <strong>Can data be migrated from older systems?</strong><br />
                        We offer data migration support to help you move from spreadsheets or legacy software.
                    </li>
                    <li>
                        <strong>Is my data secure?</strong><br />
                        We use industry-standard encryption and regular backups to ensure your data is safe and accessible.
                    </li>
                </ul>
            </section>

            {/* ACCOUNT MANAGEMENT */}
            <section className="bg-white border border-slate-200 rounded-xl p-10">
                <h2 className="text-xl font-semibold mb-4">
                    Account Management
                </h2>

                <ul className="list-disc pl-5 text-slate-600 space-y-3">
                    <li>
                        <strong>How do I reset my password?</strong><br />
                        You can reset your password via the "Forgot Password" link on the login page or from your profile settings.
                    </li>
                    <li>
                        <strong>Can I update my business details?</strong><br />
                        Yes, admins can update business information, logos, and contact details in the Settings menu.
                    </li>
                    <li>
                        <strong>How do I add new users?</strong><br />
                        Navigate to the "Users" section in the dashboard to invite new team members via email.
                    </li>
                </ul>
            </section>

            {/* OPERATIONS */}
            <section className="bg-slate-100 rounded-xl p-10">
                <h2 className="text-xl font-semibold mb-4">
                    Operational Questions
                </h2>

                <ul className="list-disc pl-5 text-slate-600 space-y-3">
                    <li>
                        <strong>How are bookings managed?</strong><br />
                        Bookings are managed through an interactive calendar view where you can drag, drop, and edit events.
                    </li>
                    <li>
                        <strong>How does EventFlow prevent double bookings?</strong><br />
                        The system automatically alerts you if you try to book a hall that is already reserved for a specific time slot.
                    </li>
                    <li>
                        <strong>How are payments tracked?</strong><br />
                        You can record partial or full payments against each booking and generate receipts instantly.
                    </li>
                    <li>
                        <strong>Can I generate custom contracts?</strong><br />
                        Yes, you can create and print custom event contracts and invoices directly from the booking details.
                    </li>
                </ul>
            </section>

            {/* BILLING & SUBSCRIPTION */}
            <section className="bg-white border border-slate-200 rounded-xl p-10">
                <h2 className="text-xl font-semibold mb-4">
                    Billing & Subscription
                </h2>

                <ul className="list-disc pl-5 text-slate-600 space-y-3">
                    <li>
                        <strong>What payment methods do you accept?</strong><br />
                        We accept all major credit cards, bank transfers, and digital wallets.
                    </li>
                    <li>
                        <strong>Can I upgrade or downgrade my plan?</strong><br />
                        Yes, you can change your subscription plan at any time from the billing section.
                    </li>
                    <li>
                        <strong>Is there a free trial available?</strong><br />
                        We offer a 14-day free trial with full access to all features so you can experience EventFlow risk-free.
                    </li>
                </ul>
            </section>

            {/* <section className="border-t pt-8 mt-12">
                <p className="text-slate-600">
                    Ready to explore more? Return to {" "}
                    <Link to="/docs/overview" className="font-medium text-[#C9A24E]">
                        Overview
                    </Link>.
                </p>
            </section> */}

            <DocNavigation
                    previous={{
                      title: "Contact Us",
                      link: "/docs/contact"
                    }}
                  />
        </section>
    );
}
